import { Link } from "react-router";
import { PageShell } from "../platform/ui/PageShell";
import { routes } from "./routes";

export function NotFoundPage() {
  return (
    <PageShell title="Page not found" lead="There is nothing at this address.">
      <p>
        <Link to={routes.home()}>Back to Orla</Link>
      </p>
    </PageShell>
  );
}
